import { isAttorneyGeneralCategory } from '../pages/wizard/attorneyGeneral/attorneyGeneralConstants';
import { FILE_CATEGORY_CIVIL_ADVISE } from '../pages/wizard/civilAdvise/civilAdviseConstants';
import { isNominationCategory } from '../pages/wizard/nomination/nominationConstants';

/** CMS-CRC-30 — common case cover note (all case types including civil advice). */
export type CommonCoverNoteResponse = {
  fileReferenceNumber: string;
  requestSubmittedAt: string;
  submittedAgency: string;
  /** Intranet submitter division/unit name. */
  submittedDivisionName: string;
  fileCategory: string;
  subFileCategory: string;
  applicableAreas: string[] | null;
  description: string | null;
  caseSource: string | null;
  urgencyLevel: string | null;
  deadline: string | null;
  urgencyJustification: string | null;
  connectedAgdFileReferenceNumber: string | null;
  accusedOrSuspectName: string | null;
  documents: string[];
  qr: string;
  /** Extradition & MLA cover note fields (GET /cover-note). */
  directionOfRequest: string | null;
  countryInvolvedName: string | null;
  provinceName: string | null;
  districtName: string | null;
  externalCaseReferenceNumber: string | null;
  otherExternalCaseReferenceNumber: string | null;
  caseNumber: string | null;
  nameOfAccused: string | null;
  nationalityName: string | null;
  passportOrNic: string | null;
  applicableTreatyOrArrangement: string | null;
  warrantReference: string | null;
};

export function isExtraditionMlaCoverNote(coverNote: Pick<CommonCoverNoteResponse, 'fileCategory'>): boolean {
  return /extradition|mutual legal assistance/i.test(coverNote.fileCategory.trim());
}

export function isCivilAppellateCoverNote(coverNote: Pick<CommonCoverNoteResponse, 'fileCategory'>): boolean {
  const name = coverNote.fileCategory.trim().toLowerCase();
  return name.includes('appellate') && name.includes('civil');
}

/** Case Type 7 — Nomination Requests cover note (on-screen display only). */
export function isNominationCoverNote(coverNote: Pick<CommonCoverNoteResponse, 'fileCategory'>): boolean {
  return isNominationCategory({ name: coverNote.fileCategory });
}

/** Case Type — Civil Division-Advise cover note. */
export function isCivilAdviseCoverNote(coverNote: Pick<CommonCoverNoteResponse, 'fileCategory'>): boolean {
  const trimmed = coverNote.fileCategory.trim();
  const name = trimmed.toLowerCase();
  if (name === FILE_CATEGORY_CIVIL_ADVISE.toLowerCase()) return true;
  if (/civil\s+division\s*[-–—]?\s*advise/i.test(trimmed)) return true;
  return name.includes('advise') && name.includes('civil');
}

/** Attorney General / AGD Internal cover note — case source is not shown on-screen. */
export function isAttorneyGeneralCoverNote(coverNote: Pick<CommonCoverNoteResponse, 'fileCategory'>): boolean {
  return isAttorneyGeneralCategory({ name: coverNote.fileCategory });
}
